import { yellow } from '@mui/material/colors';
export const tabsThemeDefinition = () => ({
    MuiTabs: {
        styleOverrides: {
            root: {
                '& .MuiTab-root': {
                    color: 'white',
                    textTransform: 'none',
                    minWidth: 'unset',
                    px: 1,
                },
                '& .MuiTab-root.Mui-selected, & .MuiTabs-indicator': {
                    color: yellow[500],
                },
                '& .MuiTabs-indicator': {
                    backgroundColor: yellow[500],
                },
            },
        },
    },
});
//# sourceMappingURL=tabsThemeDefinition.js.map